import axios from './axios';

// Users/Register is retired — it created accounts belonging to no clinic.
// Use signupClinic (create) or requestToJoinClinic (join) in saasApi.js.

export const verifyOtp = (otpInfo) => axios.post('/api/Users/VerifyOtp', otpInfo);

export const resendOtp = (email) => axios.post('/api/Users/ResendOtp?email=' + encodeURIComponent(email));

export const loginStaff = (staffInfo) => axios.post('/api/Users/Login', staffInfo); 

export const forgotPassword = (staffInfo) => axios.post('/api/Users/ForgotPassword', staffInfo); 

export const resetPassword = (staffInfo) => axios.post('/api/Users/ResetPassword', staffInfo); 